import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SvgIconModule } from '../../svg-icon';
import { TextModule } from '../../text/text.module';
import { ButtonModule } from '../button.module';

import { NavListButtonComponent } from './nav-list-button.component';

@NgModule({
  declarations: [NavListButtonComponent],
  imports: [CommonModule, SvgIconModule, ButtonModule, TextModule],
  exports: [NavListButtonComponent]
})
export class NavListButtonModule {}

export * from './nav-list-button.component';
